import { type Config } from "tailwindcss";

export const tailwindTheme: Config["theme"] = {
  colors: {
    transparent: "transparent",
    red: {
      50: "var(--color-red-50)",
      100: "var(--color-red-100)",
      200: "var(--color-red-200)",
      300: "var(--color-red-300)",
      400: "var(--color-red-400)",
      500: "var(--color-red-500)",
      600: "var(--color-red-600)",
      700: "var(--color-red-700)",
      800: "var(--color-red-800)",
      900: "var(--color-red-900)",
    },
    obsidian: {
      50: "var(--color-obsidian-50)",
      100: "var(--color-obsidian-100)",
      200: "var(--color-obsidian-200)",
      300: "var(--color-obsidian-300)",
      400: "var(--color-obsidian-400)",
      500: "var(--color-obsidian-500)",
      600: "var(--color-obsidian-600)",
      700: "var(--color-obsidian-700)",
      800: "var(--color-obsidian-800)",
      900: "var(--color-obsidian-900)",
    },
    yellow: {
      50: "var(--color-yellow-50)",
      100: "var(--color-yellow-100)",
      200: "var(--color-yellow-200)",
      300: "var(--color-yellow-300)",
      400: "var(--color-yellow-400)",
      500: "var(--color-yellow-500)",
      600: "var(--color-yellow-600)",
      700: "var(--color-yellow-700)",
      800: "var(--color-yellow-800)",
      900: "var(--color-yellow-900)",
    },
    green: {
      50: "var(--color-green-50)",
      100: "var(--color-green-100)",
      200: "var(--color-green-200)",
      300: "var(--color-green-300)",
      400: "var(--color-green-400)",
      500: "var(--color-green-500)",
      600: "var(--color-green-600)",
      700: "var(--color-green-700)",
      800: "var(--color-green-800)",
      900: "var(--color-green-900)",
    },
    blue: {
      50: "var(--color-blue-50)",
      100: "var(--color-blue-100)",
      200: "var(--color-blue-200)",
      300: "var(--color-blue-300)",
      400: "var(--color-blue-400)",
      500: "var(--color-blue-500)",
      600: "var(--color-blue-600)",
      700: "var(--color-blue-700)",
      800: "var(--color-blue-800)",
      900: "var(--color-blue-900)",
    },
    peach: {
      50: "var(--color-peach-50)",
      100: "var(--color-peach-100)",
      200: "var(--color-peach-200)",
      300: "var(--color-peach-300)",
      400: "var(--color-peach-400)",
      500: "var(--color-peach-500)",
      600: "var(--color-peach-600)",
      700: "var(--color-peach-700)",
      800: "var(--color-peach-800)",
      900: "var(--color-peach-900)",
    },
    walnut: {
      50: "var(--color-walnut-50)",
      100: "var(--color-walnut-100)",
      200: "var(--color-walnut-200)",
      300: "var(--color-walnut-300)",
      400: "var(--color-walnut-400)",
      500: "var(--color-walnut-500)",
      600: "var(--color-walnut-600)",
      700: "var(--color-walnut-700)",
      800: "var(--color-walnut-800)",
      900: "var(--color-walnut-900)",
    },
    hazel: {
      50: "var(--color-hazel-50)",
      100: "var(--color-hazel-100)",
      200: "var(--color-hazel-200)",
      300: "var(--color-hazel-300)",
      400: "var(--color-hazel-400)",
      500: "var(--color-hazel-500)",
      600: "var(--color-hazel-600)",
      700: "var(--color-hazel-700)",
      800: "var(--color-hazel-800)",
      900: "var(--color-hazel-900)",
    },
    bittersweet: {
      50: "var(--color-bittersweet-50)",
      100: "var(--color-bittersweet-100)",
      200: "var(--color-bittersweet-200)",
      300: "var(--color-bittersweet-300)",
      400: "var(--color-bittersweet-400)",
      500: "var(--color-bittersweet-500)",
      600: "var(--color-bittersweet-600)",
      700: "var(--color-bittersweet-700)",
      800: "var(--color-bittersweet-800)",
      900: "var(--color-bittersweet-900)",
    },
    white: "#ffffff",
    background: "white",
    black: "#000000",
    primary: "var(--color-obsidian-800)",
    "primary-foreground": "var(--color-hazel-500)",
    secondary: "var(--color-hazel-200)",
    "secondary-foreground": "var(--color-obsidian-800)",
    ring: "var(--color-hazel-500)",
    destructive: "var(--color-red-500)",
    "destructive-foreground": "white",
    accent: "var(--color-hazel-100)",
    input: "var(--color-obsidian-300)",
    backdrop: "#2E424850",
    card: {
      "default-bg": "var(--color-card-default-bg)",
      "default-content": "var(--color-card-default-content)",
      "success-bg": "var(--color-card-success-bg)",
      "success-content": "var(--color-card-success-content)",
      "info-bg": "var(--color-card-info-bg)",
      "info-content": "var(--color-card-info-content)",
      "warning-bg": "var(--color-card-warning-bg)",
      "warning-content": "var(--color-card-warning-content)",
      "problem-bg": "var(--color-card-problem-bg)",
      "problem-content": "var(--color-card-problem-content)",
      "danger-bg": "var(--color-card-danger-bg)",
      "danger-content": "var(--color-card-danger-content)",
      "orange-bg": "var(--color-card-orange-bg)",
      "orange-content": "var(--color-card-orange-content)",
    },
  },
  extend: {
    fontFamily: {
      sans: ["var(--figtree)"],
    },
    fontSize: {
      xs: ["0.812rem", "1.4"],
      sm: ["1rem", "1.4"],
      base: ["1.25rem", "1.4"],
      lg: ["1.562rem", "1.4"],
      xl: ["1.938rem", "1.4"],
      "2xl": ["2.438rem", "1.4"],
      "3xl": ["3.062rem", "1.15"],
      "4xl": ["3.812rem", "1.1"],
      "5xl": ["4.750rem", "1.05"],
      "6xl": ["5.938rem", "1"],
    },
    spacing: {
      0: "0",
      1: "0.25rem",
      2: "0.5rem",
      3: "0.8125rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5625rem",
      7: "1.9375rem",
      8: "2.4375rem",
      9: "3.0625rem",
      10: "3.8125rem",
      11: "4.75rem",
      12: "5.9375rem",
      13: "7.421rem",
      14: "9.2763rem",
      15: "11.5953rem",
      16: "14.4941rem",
      17: "18.1176",
    },
    borderRadius: {
      none: "0",
      sm: "0.25rem",
      md: "0.5rem",
      lg: "1rem",
      xl: "1.25rem",
      "2xl": "1.56rem",
      "3xl": "1.9375rem",
      full: "9999px",
    },
    ease: {
      smooth: "cubic-bezier(0.455, 0.270, 0.275, 0.940)",
    },
    animation: {
      "fade-in": "fade-in 300ms",
      "fade-out": "fade-out 300ms",
      "translate-in": "translate-in 0.3s",
      "translate-out": "translate-out 0.3s",
      "translate-top-in": "translate-top-in 0.3s",
      "translate-top-out": "translate-top-out 0.3s",
      "swing-in": "swing-in 0.2s",
      "swing-out": "swing-out 0.2s",
      "slide-in-bottom": "slide-in-bottom 0.3s",
      "slide-out-bottom": "slide-out-bottom 0.3s",
    },
    keyframes: {
      "fade-in": {
        "0%": { opacity: "0" },
        "100%": { opacity: "1" },
      },
      "fade-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0" },
      },
      "translate-in": {
        "0%": { opacity: "0", transform: "translateX(10px)" },
        "100%": { opacity: "1" },
      },
      "translate-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0", transform: "translateX(-10px)" },
      },
      "translate-top-in": {
        "0%": { opacity: "0", transform: "translateY(-10px)" },
        "100%": { opacity: "1" },
      },
      "translate-top-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0", transform: "translateY(-10px)" },
      },
      "swing-in": {
        "0%": {
          opacity: "0",
          transform:
            "scale(0.95) perspective(1000px) rotateX(-3deg) translateY(-0.5rem)",
        },
        "100%": {
          opacity: "1",
          transform:
            "scale(1) perspective(1000px) rotateX(0deg) translateY(0rem)",
        },
      },
      "swing-out": {
        "0%": {
          opacity: "1",
          transform:
            "scale(1) perspective(1000px) rotateX(0deg) translateY(0rem)",
        },
        "100%": {
          opacity: "0",
          transform:
            "scale(0.95) perspective(1000px) rotateX(-3deg) translateY(-0.5rem)",
        },
      },
      "slide-in-bottom": {
        "0%": { opacity: "0", transform: "translateY(5rem)" },
        "100%": { opacity: "1", transform: "translateY(0)" },
      },
      "slide-out-bottom": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(5rem)" },
      },
    },
  },
};
